
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-23a7a8e9&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./passwords.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./passwords.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-23a7a8e9!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./passwords.vue"),
  /* scopeId */
  "data-v-23a7a8e9",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/view/component/passwords.vue
// module id = 148
// module chunks = 2